import { CustomerEntryName } from '../../utils/step-engine-constants';
import {
  ADD_CUSTOMER_ENTRY,
  ADD_GLOBAL_DATA,
  ADD_REPEATABLE_GLOBAL_DATA,
  REMOVE_REPEATABLE_GLOBAL_DATA,
  REMOVE_GLOBAL_DATA,
  REMOVE_DECLARATION_GLOBAL_DATA,
  SET_ADDITIONAL_STEP,
  SET_BACK_TO_HOME,
  SET_COVER,
  SET_COVER_DISPLAY_NAME,
  SET_CURRENT_STEP,
  SET_CUSTOMER_ENTRY,
  REMOVE_CUSTOMER_ENTRY,
  SET_DONT_SHOW_POPUP_REDIRECT_URL,
  SET_GO_TO_LOGIN_ERROR,
  SET_RECEIVED_STEP,
  SET_SHOW_ELIGIBILITY_MODAL,
  SET_SHOW_ERROR_MODAL,
  SET_SHOW_RATING_MODAL,
  SET_SHOW_STEP_ACTION,
  SET_STEP_ENGINE_DEVICE_TYPE,
  SET_STEP_ENGINE_SUBSCRIPTION,
  SET_STEP_ENGINE_SUBSCRIBER,
  SET_STEP_ENGINE_CREATED_CLAIM,
  SET_DISABLED_NEXT_BUTTON,
  SET_STEP_GROUP,
  SET_LAST_EDIT_STEP,
  SET_CURRENT_STEP_GROUP,
  ADD_NEXT_STEP_TO_STEP_LIST,
  REMOVE_STEP_FROM_STEP_LIST,
  ADD_COMPONENT_DATA_TO_ONE_STEP,
  DECREMENT_INSURED_GROUP_INDEX_COMPONENT,
  SET_COMPONENT_LIST,
  REMOVE_STEP_FROM_STEP_LIST_BY_INDEX_AND_NAME,
  REMOVE_STEPS_FROM_STEP_LIST_AFTER_INDEX,
  REMOVE_INSURED_GOOD_BY_INDEX,
  REMOVE_INSURED_GROUP_BY_INDEX,
  SET_LAST_REPEATABLE_STEP_GROUP,
  ADD_STEP_GROUP_TO_ONE_STEP,
  SET_CURRENT_REPEATABLE_STEP_GROUP,
  REMOVE_REPEATABLE_DECLARATION_GLOBAL_DATA,
  DECREMENT_LAST_REPEATABLE_STEP_GROUP,
  DECREMENT_CURRENT_REPEATABLE_STEP_GROUP,
} from './step-engine-actions';
import { StepList } from './step-engine-state';

export const setReceivedStep = (received: string[]) => dispatch => {
  dispatch({
    type: SET_RECEIVED_STEP,
    payload: received,
  });
};

export const setCurrentStep = (steps: string[]) => dispatch => {
  dispatch({
    type: SET_CURRENT_STEP,
    payload: steps,
  });
};

export const setCurrentRepeatableStepGroup = (index: number) => dispatch => {
  dispatch({
    type: SET_CURRENT_REPEATABLE_STEP_GROUP,
    payload: index,
  });
};

export const addNextStepToStepList = (step: StepList, currentIndex: number) => dispatch => {
  dispatch({
    type: ADD_NEXT_STEP_TO_STEP_LIST,
    payload: {
      step,
      currentIndex
    }
  });
};

export const addComponentDataToOneStep = (currentIndex: number, component: {}) => dispatch => {
  dispatch({
    type: ADD_COMPONENT_DATA_TO_ONE_STEP,
    payload: {
      currentIndex,
      component
    }
  });
};

export const decrementInsuredGroupIndexComponent = (stepIndex: number) => dispatch => {
  dispatch({
    type: DECREMENT_INSURED_GROUP_INDEX_COMPONENT,
    payload: {
      stepIndex,
    }
  });
};

export const addStepGroupToOneStep = (currentIndex: number, stepGroup: string) => dispatch => {
  dispatch({
    type: ADD_STEP_GROUP_TO_ONE_STEP,
    payload: {
      currentIndex,
      stepGroup
    }
  });
};

export const removeStepFromStepList = (stepIndex: number) => dispatch => {
  dispatch({
    type: REMOVE_STEP_FROM_STEP_LIST,
    payload: stepIndex,
  });
}

export const removeStepFromStepListByIndexAndName = (index: number, stepName: string) => dispatch => {
  dispatch({
    type: REMOVE_STEP_FROM_STEP_LIST_BY_INDEX_AND_NAME,
    payload: {
      index,
      stepName,
    }
  });
}

export const removeStepsFromStepListAfterIndex = (stepIndex: number) => dispatch => {
  dispatch({
    type: REMOVE_STEPS_FROM_STEP_LIST_AFTER_INDEX,
    payload: stepIndex
  });
}

export const removeInsuredGoodByIndex = (index: number) => dispatch => {
  dispatch({
    type: REMOVE_INSURED_GOOD_BY_INDEX,
    payload: { index },
  });
}

export const removeInsuredGroupByIndex = (index: number) => dispatch => {
  dispatch({
    type: REMOVE_INSURED_GROUP_BY_INDEX,
    payload: { index },
  });
}

export const setComponentList = (views: Map<any, any>) => dispatch => {
  dispatch({
    type: SET_COMPONENT_LIST,
    payload: { views }
  })
}

export const setCurrentStepGroup = (stepGroup: string) => dispatch => {
  dispatch({
    type: SET_CURRENT_STEP_GROUP,
    payload: stepGroup,
  });
};

export const setLastEditStep = (step: string) => dispatch => {
  dispatch({
    type: SET_LAST_EDIT_STEP,
    payload: step,
  });
};

export const setAdditionalStep = (step: string) => dispatch => {
  dispatch({
    type: SET_ADDITIONAL_STEP,
    payload: step,
  });
};

export const setCover = (cover: string) => async dispatch => {
  await dispatch({
    type: SET_COVER,
    payload: cover,
  });
};

export const setCoverDisplayName = (coverDisplayName: string) => async dispatch => {
  await dispatch({
    type: SET_COVER_DISPLAY_NAME,
    payload: coverDisplayName,
  });
};

export const setCustomerEntry = (customerEntry: Map<CustomerEntryName, any>) => async dispatch => {
  await dispatch({
    type: SET_CUSTOMER_ENTRY,
    payload: customerEntry,
  });
};

export const addCustomerEntry = (customerEntryName: CustomerEntryName, value: any) => async dispatch => {
  await dispatch({
    type: ADD_CUSTOMER_ENTRY,
    payload: { customerEntryName, value },
  });
};

export const removeCustomerEntry = (customerEntryName: CustomerEntryName) => async dispatch => {
  await dispatch({
    type: REMOVE_CUSTOMER_ENTRY,

    payload: { customerEntryName },
  });
};

export const addGlobalData = (key: string, value: any) => async dispatch => {
  await dispatch({
    type: ADD_GLOBAL_DATA,
    payload: { key, value },
  });
};

export const addRepeatableGlobalData = (key: string, value: any, repeatableStepGroupIndex: number) => async dispatch => {
  await dispatch({
    type: ADD_REPEATABLE_GLOBAL_DATA,
    payload: { key, value, repeatableStepGroupIndex },
  });
}

export const removeRepeatableGlobalData = (key: string, repeatableStepGroupIndex: number) => async (dispatch, getState) => {
  const insuredGoods = getState().stepEngine.declarationGlobalData.insuredGoods;
  if (insuredGoods && insuredGoods.length > 0) {
    await dispatch({
      type: REMOVE_REPEATABLE_GLOBAL_DATA,
      payload: { key, repeatableStepGroupIndex },
    });
  } else {
    console.log("Insured goods est vide.");
  }
};

export const removeGlobalData = (key: string) => async dispatch => {
  await dispatch({
    type: REMOVE_GLOBAL_DATA,
    payload: { key },
  });
};

export const removeDeclarationGlobalData = (key: string) => async dispatch => {
  await dispatch({
    type: REMOVE_DECLARATION_GLOBAL_DATA,
    payload: { key },
  });
};

export const removeRepeatableDeclarationGlobalData = (insuredGroupIndex: number) => async dispatch => {
  await dispatch({
    type: REMOVE_REPEATABLE_DECLARATION_GLOBAL_DATA,
    payload: { insuredGroupIndex },
  });
};

export const setStepEngineSubscription = (data: any) => async dispatch => {
  await dispatch({
    type: SET_STEP_ENGINE_SUBSCRIPTION,
    payload: {
      ...data,
      insuredGoods: data.insuredGoods.filter(ig => ig.active === true),
    },
  });
};

export const setStepEngineSubscriber = (data: any) => async dispatch => {
  await dispatch({
    type: SET_STEP_ENGINE_SUBSCRIBER,
    payload: data,
  });
};

export const setStepEngineCreatedClaim = data => async dispatch => {
  await dispatch({
    type: SET_STEP_ENGINE_CREATED_CLAIM,
    payload: data,
  });
};

export const setBackToHome = (backToHome: boolean) => async dispatch => {
  await dispatch({
    type: SET_BACK_TO_HOME,
    payload: backToHome,
  });
};

export const setGoToLoginError = (goToLoginError: boolean) => async dispatch => {
  await dispatch({
    type: SET_GO_TO_LOGIN_ERROR,
    payload: goToLoginError,
  });
};

export const setShowEligibilityModal = (showEligibilityModal: boolean) => async dispatch => {
  await dispatch({
    type: SET_SHOW_ELIGIBILITY_MODAL,
    payload: showEligibilityModal,
  });
};

export const setDisabledNextButton = (stepIndex: number, disableNextButton: boolean) => async dispatch => {
  await dispatch({
    type: SET_DISABLED_NEXT_BUTTON,
    payload: { stepIndex, disableNextButton },
  });
};

export const setShowRatingModal = (showRatingModal: boolean) => async dispatch => {
  await dispatch({
    type: SET_SHOW_RATING_MODAL,
    payload: showRatingModal,
  });
};

export const setShowErrorModal = (showErrorModal: boolean) => async dispatch => {
  await dispatch({
    type: SET_SHOW_ERROR_MODAL,
    payload: showErrorModal,
  });
};

export const setShowStepAction = (showStepAction: boolean) => async dispatch => {
  await dispatch({
    type: SET_SHOW_STEP_ACTION,
    payload: showStepAction,
  });
};

export const setStepGroup = (stepGroup: string) => async dispatch => {
  await dispatch({
    type: SET_STEP_GROUP,
    payload: stepGroup,
  });
};

export const setDontShowPopupRedirectUrl = (dontShowPopupRedirectUrl: boolean) => async dispatch => {
  await dispatch({
    type: SET_DONT_SHOW_POPUP_REDIRECT_URL,
    payload: dontShowPopupRedirectUrl,
  });
};
export const setStepEngineDeviceType = (deviceType: string) => async dispatch => {
  await dispatch({
    type: SET_STEP_ENGINE_DEVICE_TYPE,
    payload: deviceType,
  });
};

export const setLastRepeatableStepGroup = (lastRepeatableStepGroup: number) => async dispatch => {
  await dispatch({
    type: SET_LAST_REPEATABLE_STEP_GROUP,
    payload: {
      lastRepeatableStepGroup
    }
  })
}

export const decrementLastRepeatableStepGroup = () => async dispatch => {
  await dispatch({
    type: DECREMENT_LAST_REPEATABLE_STEP_GROUP
  })
}

export const decrementCurrentRepeatableStepGroup = () => async dispatch => {
  await dispatch({
    type: DECREMENT_CURRENT_REPEATABLE_STEP_GROUP
  })
}
